<template>
  <div class="content-wrap">
    <div class="main">
      <div class="container-fluid">
        <!-- /# row -->
        <section id="main-content">
          <div id="currentDate">統計日期：{{stateDate}}</div>
          <div class="cardGroup" v-if="lastTotalAry">
            <div class="row">
              <div
                class="col-lg-3"
                v-for="dep in lastTotalAry"
                :key="dep.index"
                :data-dep="dep.code"
              >
                <div class="card">
                  <div class="stat-widget-one">
                    <div class="d-flex">
                      <div class="stat-text">{{dep.name}}</div>
                      <div class="stat-digit d-flex">{{dep.lastTotal}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 長條圖 -->
          <div class="row">
            <div class="col-lg-8">
              <div class="card">
                <div class="card-title">
                  <h4>
                    <strong>最近一週</strong>
                  </h4>
                </div>
                <div class="card-body">
                  <div>
                    <canvas id="weeklyPlot"></canvas>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="card IndexProgressGroup">
                <div class="card-title">
                  <h4>
                    <strong>網路銷售</strong>
                  </h4>
                </div>
                <ul v-if="webData">
                  <li v-for="(dep,index) in webData" :key="index">
                    {{dep.depName}}
                    <div :data-dep="dep.dep">
                      <h6 class="mt-1">
                        <strong>{{dep.YesWeb}} 件</strong>
                        <span class="pull-right">{{dep.percent}} %</span>
                      </h6>
                      <div class="progress">
                        <div
                          class="progress-bar wow animated progress-animated"
                          :class="'bg-'+mainColorObj[dep.dep]['colorName']"
                          style="height:6px;"
                          :style="'width:'+dep.percent+'%'"
                          role="progressbar"
                        >
                          <span class="sr-only">{{dep.percent}}% Complete</span>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- <div id="IndexconvertGroup">
            <h5>
              <strong>轉檔狀態</strong>
            </h5>
            <div class="row">
              <div class="col-lg-3">
                <div class="card">
                  <div class="pieChart">
                    <p data-dep="poster"></p>
                    <div>
                      <canvas data-dep="poster"></canvas>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-3">
                <div class="card">
                  <div class="pieChart">
                    <p data-dep="card"></p>
                    <div>
                      <canvas data-dep="card"></canvas>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-3">
                <div class="card">
                  <div class="pieChart">
                    <p data-dep="ink"></p>
                    <div>
                      <canvas data-dep="ink"></canvas>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-3">
                <div class="card">
                  <div class="pieChart">
                    <p data-dep="digit"></p>
                    <div>
                      <canvas data-dep="digit"></canvas>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>-->
        </section>
        <div class="trackingGroup"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    mainColorObj: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      stateDate: "2019-12-06",
      depAry: [],
      deps: {
        poster: {
          dep: "poster",
          YesTotal: 0,
          YesWeb: 0,
          percent: 0,
          depName: ""
        },
        card: {
          dep: "card",
          YesTotal: 0,
          YesWeb: 0,
          percent: 0,
          depName: ""
        },
        ink: {
          dep: "ink",
          YesTotal: 0,
          YesWeb: 0,
          percent: 0,
          depName: ""
        },
        digit: {
          dep: "digit",
          YesTotal: 0,
          YesWeb: 0,
          percent: 0,
          depName: ""
        }
      }
    };
  },
  async created() {
    await this.$store.dispatch("GET_DATA");
    this.depAry = await this.$store.state.departmentAry;
  },
  computed: {
    lastTotalAry() {
      if (!this.mainData.poster) return false;
      return this.depAry.reduce((prev, curr) => {
        curr.lastTotal = this.mainData[curr.code][this.stateDate].total;
        prev.push(curr);
        return prev;
      }, []);
    },
    mainData() {
      return this.$store.state.mainData;
    },
    webData() {
      return this.deps.poster.YesTotal === 0 ? false : this.deps;
    },
    dateAry() {
      let ary = [];
      if (this.mainData.poster) {
        for (let i in this.mainData.poster) {
          ary.push(i);
        }
      }
      return ary;
    }
  },
  methods: {
    getAIPSTotalCountIndex(lastDate) {
      let datasets = [],
        datas = [],
        obj = {},
        pieAry = [];
      // console.log(this.mainData["poster"]["2019-12-06"]);
      if (!this.mainData["poster"]) {
        return;
      }
      this.depAry.forEach(el => {
        datas = [];
        pieAry = [];
        this.deps[el.code]["YesTotal"] = this.mainData[el.code][lastDate].total;
        this.deps[el.code]["YesWeb"] = this.mainData[el.code][lastDate].web;
        this.deps[el.code]["depName"] =
          el.code === "poster"
            ? "產品1"
            : el.code === "card"
            ? "產品2"
            : el.code === "ink"
            ? "產品3"
            : "產品4";
        this.deps[el.code]["percent"] =
          this.deps[el.code]["YesTotal"] > 0 && this.deps[el.code]["YesWeb"] > 0
            ? (
                (this.deps[el.code]["YesWeb"] /
                  this.deps[el.code]["YesTotal"]) *
                100
              ).toFixed(2)
            : 0;

        for (let i in this.mainData[el.code]) {
          let percent = (
            ((this.mainData[el.code][i].web * 1) /
              (this.mainData[el.code][i].total * 1)) *
            100
          ).toFixed(2);
          datas.push(percent);
        }
        let obj = {
          borderColor: this.mainColorObj[el.code].color,
          backgroundColor: this.mainColorObj[el.code].color,
          label: this.deps[el.code]["depName"],
          fill: false,
          data: datas
        };
        datasets.push(obj);
      });
      let chart = plotLine("weeklyPlot", this.dateAry, datasets);
    }
  },
  watch: {
    mainData: function(newVal, oldVal) {
      this.getAIPSTotalCountIndex(this.stateDate);
    }
  }
};

function plotPieConvertReport(dep, labels, data) {
  let ctx = document.querySelector(`canvas[data-dep="${dep}"]`);
  if (!ctx) return;
  ctx = ctx.getContext("2d");
  let chart = new Chart(ctx, {
    type: "pie",
    data: {
      labels: labels,
      datasets: [
        {
          //預設資料
          data: data,
          backgroundColor: ["#EFA2A9", "#D1ECF1", "#E2E3E5"] // 4 1 0
        }
      ]
    }
  });
}

function plotLine(domID, labels, datasets) {
  let ctx = document.getElementById(domID);
  if (!ctx) return;
  ctx = ctx.getContext("2d");
  let chart = new Chart(ctx, {
    type: "line",
    responsive: true,
    data: {
      labels: labels,
      datasets: datasets
    },
    options: {
      scales: {
        yAxes: [
          {
            scaleLabel: {
              display: true,
              labelString: "web 百分比"
            },
            ticks: {
              beginAtZero: true,
              steps: 10,
              stepValue: 5,
              max: 100
            }
          }
        ]
      },
      steppedLine: true,
      tooltips: {
        mode: "label",
        position: "nearest"
      }
    }
  });
  return chart;
}
</script>

<style>
.IndexProgressGroup {
  background-color: #d1ecf1 !important;
  color: #000;
  height: inherit;
}
</style>